import React from "react";
import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import PropTypes from "prop-types";

const FileCaseSummary = ({ fileCase, visible, onBackClick }) => {
    return (
        <div
            className={clsx("layout client-summary-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && fileCase && (
                <>
                    <h3>Client's case</h3>
                    <Card>
                        <div>
                            <span>{fileCase?.fileNo}</span>
                        </div>
                        <Button secondary link onClick={onBackClick}>
                            <Icon name="cancel" color="secondary" size="xs" />
                        </Button>
                    </Card>
                </>
            )}
        </div>
    );
};

FileCaseSummary.propTypes = {
    fileCase: PropTypes.object,
    visible: PropTypes.bool,
    onBackClick: PropTypes.func,
};

FileCaseSummary.defaultProps = {
    fileCase: undefined,
    visible: true,
    onBackClick: () => {},
};

export default FileCaseSummary;
